(function () {
    'use strict';

    angular
        .module('appback')
        .controller('ContactosController', ContactosController)

    ContactosController.$inject = ["$timeout", "Upload", "ContactosService"];

    /**
     * Listado de contactos (backend/views/contacto/contactos.php): tarjetas por
     * estado que filtran, buscador (con espera de BUSQUEDA_MS para no pedir
     * una página por tecla), paginación y botón "Escanear tarjeta".
     */
    function ContactosController($timeout, Upload, ContactosService) {
        var ct = this;
        var BUSQUEDA_MS = 350;
        var busqueda = null;
        // Solo se pinta la respuesta de la última petición: con la espera de
        // la búsqueda pueden quedar varias en vuelo.
        var peticion = 0;

        ct.loading = false;
        ct.error = false;
        ct.items = [];
        ct.total = 0;
        ct.page = 1;
        ct.pageSize = 20;
        ct.resumen = { total: 0, estados: {} };
        ct.filtro = { q: '', estado: '' };
        ct.tarjeta = { uploading: false, success: false, message: '' };
        var tarjetaModal = null;

        ct.init = function () {
            ct.cargar();
        };

        ct.cargar = function () {
            var esta = ++peticion;
            ct.loading = true;

            return ContactosService.Listado({
                q: ct.filtro.q,
                estado: ct.filtro.estado,
                page: ct.page,
                pageSize: ct.pageSize
            }).then(function (data) {
                if (esta !== peticion) {
                    return;
                }
                ct.error = false;
                ct.items = data.items || [];
                ct.total = data.total;
                ct.page = data.page;
                ct.resumen = data.resumen;
            }, function () {
                if (esta === peticion) {
                    ct.error = true;
                }
            }).finally(function () {
                if (esta === peticion) {
                    ct.loading = false;
                }
            });
        };

        ct.filtrar = function (estado) {
            ct.filtro.estado = estado;
            ct.page = 1;
            ct.cargar();
        };

        ct.buscar = function () {
            $timeout.cancel(busqueda);
            busqueda = $timeout(function () {
                ct.page = 1;
                ct.cargar();
            }, BUSQUEDA_MS);
        };

        ct.totalPaginas = function () {
            return Math.max(1, Math.ceil(ct.total / ct.pageSize));
        };

        ct.irAPagina = function (page) {
            if (page < 1 || page > ct.totalPaginas()) {
                return;
            }
            ct.page = page;
            ct.cargar();
        };

        // Misma subida que el botón "Subir tarjeta de visita" del dashboard
        // (dashboard.controller.js): sin id, ContactoController::actionSubirtarjeta()
        // crea un contacto en blanco con la foto, que se ve ya en el listado.
        ct.subirTarjeta = function (input) {
            if (!input.files || !input.files[0]) {
                return;
            }

            var file = input.files[0];
            input.value = '';
            ct.tarjeta.uploading = true;

            Upload.upload({
                url: '/backend/contacto/subirtarjeta',
                data: { file: file }
            }).then(function (res) {
                ct.tarjeta.success = !!res.data.success;
                ct.tarjeta.message = res.data.msg || 'La tarjeta se ha enviado para procesar.';
                if (ct.tarjeta.success) {
                    ct.filtro.estado = '';
                    ct.page = 1;
                    ct.cargar();
                }
            }).catch(function () {
                ct.tarjeta.success = false;
                ct.tarjeta.message = 'No se ha podido subir la tarjeta de visita.';
            }).finally(function () {
                ct.tarjeta.uploading = false;
                if (!tarjetaModal) {
                    tarjetaModal = new bootstrap.Modal(document.getElementById('contactosTarjetaModal'));
                }
                tarjetaModal.show();
            });
        };

        ct.nombre = function (contacto) {
            var nombre = [contacto.nombre, contacto.apellidos].filter(Boolean).join(' ');

            return nombre || contacto.email || contacto.telefono || ('#' + contacto.id);
        };
    }
})();
